import React, { useState } from "react";
import { Link } from "react-router-dom";
import { HiExternalLink } from "react-icons/hi";

const projects = [
  {
    image: "/images/portfolio/autofoto.png",
    title: "AutoFoto",
    category: "Software",
    year: "2025",
    techStack: ["Flutter", "Google ML", "Python"],
    description: "Transform your car photos into stunning studio shots with our AI technology.",
    comingSoon: true,
  },
  {
    image: "/images/portfolio/ai lab.png",
    title: "AI & Tech Curriculum",
    category: "Education",
    readMore: "/blog/ai-edu-tech-curriculum",
    isInternal: true,
  },
  {
    image: "/images/portfolio/ecommerce.png",
    title: "Custom E-Commerce Platform",
    category: "Software",
    techStack: ["Next.js", "MySQL"],
    description: "Find WooCommerce and Shopify annoying and expensive? Get your own customized e-commerce website and manage everything in one click with more freedom.",
  },
  {
    image: "/images/portfolio/col2-row2a(1).png",
    title: "HexaPi Delivery",
    category: "Software",
    year: "2022",
    techStack: ["Flutter", "Firebase", "PHP"],
    readMore: "https://hexapi.tech/delivery.html",
    demo: "https://hexapi.tech/delivery",
  },
  {
    image: "/images/portfolio/col3-row3.png",
    title: "HexaPi Auction",
    category: "Software",
    year: "2021",
    techStack: ["Node.js", "WebRTC"],
    readMore: "https://hexapi.tech/auction.html",
  },
  {
    image: "/images/portfolio/col2-row2a(2).png",
    title: "Smart School",
    category: "Software",
    year: "2020",
    techStack: ["Flutter", "Firebase", "Google Cloud"],
    readMore: "https://hexapi.tech/school.html",
    demo: "https://e-school-a0cd4.web.app/#/",
  },
  {
    image: "/images/portfolio/col2-row2a(3).png",
    title: "NSSF: Appointment Booking",
    category: "Software",
    year: "2020",
    techStack: ["Flutter", "PHP", "Google Cloud"],
    readMore: "https://hexapi.tech/booking.html",
  },
  {
    image: "/images/portfolio/tabiby.png",
    title: "Tabiby",
    category: "Software",
    year: "2024",
    techStack: ["React", "MUI", "MySQL"],
    discontinued: true,
  },
  {
    image: "/images/portfolio/IMG_20220511_141521_770.jpg",
    title: "Solar Energy",
    category: "Electronics",
    readMore: "https://hexapi.tech/solar/",
  },
  {
    image: "/images/portfolio/summer_internship.png",
    title: "Summer Internships",
    category: "Education",
    readMore:
      "https://m.facebook.com/story.php?story_fbid=pfbid0Q7jWnoGEj5jWnGgXXkDnUFjriD8GkQVLweqGZ8kJ6NgF6fwcnb25m3XKMp7yuGYal&id=100029105125143&mibextid=Nif5oz",
  },
  {
    image: "/images/portfolio/My project.png",
    title: "Control & Automation",
    category: "Electronics",
  },
  {
    image: "/images/portfolio/Safe Plug Portfolio(1).png",
    title: "Safe Plug Invention",
    category: "Electronics",
    year: "2019",
    readMore: "https://youtu.be/3BU2JRAVFCM",
  },
  {
    image: "/images/portfolio/s-l640-2431179748.jpeg",
    title: "Automatic Stair Lights",
    category: "Electronics",
    readMore:
      "https://www.facebook.com/HexaPiTech/photos/a.111100613798111/539765904264911/",
  },
  {
    image: "/images/portfolio/cms.jpg",
    title: "PortfolioCraft CMS",
    category: "Software",
    year: "2025",
    techStack: ["Next.js", "Directus", "MySQL"],
    description: "Build your company portfolio website using our easy CMS system. Less Expenses, More Freedom. Easier than WordPress.",
  },
];

const ProjectCard = ({
  image,
  title,
  category,
  year,
  techStack,
  description,
  readMore,
  isInternal,
  comingSoon,
  discontinued,
}) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <div
      className="group bg-white rounded-lg overflow-hidden shadow-card
                  hover:shadow-card-hover hover:-translate-y-1 transition-all duration-300"
    >
      <div className="relative overflow-hidden h-32 sm:h-36">
        <img
          src={image}
          alt={title}
          className="w-full h-full object-cover group-hover:scale-105
                     transition-transform duration-500"
        />
        <span
          className="absolute top-2 left-2 px-2 py-0.5 bg-gray-200 rounded-full
                       text-[10px] font-medium text-neutral-dark"
        >
          {category}
        </span>
        {comingSoon && (
          <span
            className="absolute top-2 right-2 px-2 py-0.5 bg-amber-500 text-white rounded-full
                       text-[10px] font-medium"
          >
            Coming Soon
          </span>
        )}
        {discontinued && (
          <span
            className="absolute top-2 right-2 px-2 py-0.5 bg-red-500 text-white rounded-full
                       text-[10px] font-medium"
          >
            Discontinued
          </span>
        )}
      </div>
      <div className="p-3 sm:p-4">
        <div className="flex items-center justify-between gap-2 mb-2">
          <h4 className="text-sm sm:text-base font-semibold text-neutral-dark line-clamp-1">
            {title}
          </h4>
          {year && (
            <span className="shrink-0 px-2 py-0.5 border border-primary-400 text-primary-500 rounded text-[10px] font-medium">
              {year}
            </span>
          )}
        </div>
        {techStack && techStack.length > 0 && (
          <div className="flex flex-wrap gap-1 mb-2">
            {techStack.map((tech, index) => (
              <span
                key={index}
                className="px-2 py-0.5 bg-gray-100 text-gray-600 rounded-full text-[10px]"
              >
                {tech}
              </span>
            ))}
          </div>
        )}
        {description && expanded && (
          <p className="text-xs text-neutral mb-2 leading-relaxed">
            {description}
          </p>
        )}
        <div className="flex flex-wrap gap-2">
          {description && (
            <button
              onClick={() => setExpanded(!expanded)}
              className="inline-flex items-center gap-1 text-xs font-medium
                         text-primary-500 hover:text-primary-600 transition-colors"
            >
              {expanded ? "Show Less" : "Read More"}
            </button>
          )}
          {readMore && isInternal ? (
            <Link
              to={readMore}
              className="inline-flex items-center gap-1 text-xs font-medium
                         text-primary-500 hover:text-primary-600 transition-colors"
            >
              <HiExternalLink className="w-3.5 h-3.5" />
              Read More
            </Link>
          ) : readMore ? (
            <a
              href={readMore}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1 text-xs font-medium
                         text-primary-500 hover:text-primary-600 transition-colors"
            >
              <HiExternalLink className="w-3.5 h-3.5" />
              Read More
            </a>
          ) : null}
        </div>
      </div>
    </div>
  );
};

const Portfolio = () => {
  const [filter, setFilter] = useState("All");
  const [showAll, setShowAll] = useState(false);
  const categories = ["All", "Software", "Electronics", "Education"];
  const INITIAL_LIMIT = 8;

  const filteredProjects =
    filter === "All" ? projects : projects.filter((p) => p.category === filter);

  const visibleProjects = showAll
    ? filteredProjects
    : filteredProjects.slice(0, INITIAL_LIMIT);

  const hasMore = filteredProjects.length > INITIAL_LIMIT;

  return (
    <section id="portfolio" className="py-10 lg:py-14 bg-primary-50">
      <div className="max-w-6xl mx-auto px-4 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <span className="section-subheading">Our Work</span>
          <h2 className="section-heading">Portfolio</h2>
          <div className="w-20 h-1 bg-primary-500 mx-auto mt-4 rounded-full"></div>
        </div>

        {/* Filter Tabs */}
        <div className="flex flex-wrap justify-center gap-2 md:gap-3 mb-8 md:mb-12">
          {categories.map((cat) => (
            <button
              key={cat}
              onClick={() => {
                setFilter(cat);
                setShowAll(false);
              }}
              className={`px-4 py-2 md:px-6 md:py-2.5 text-sm md:text-base rounded-full font-medium transition-all duration-300
                ${
                  filter === cat
                    ? "bg-primary-500 text-white shadow-card"
                    : "bg-white text-neutral hover:bg-primary-100 hover:text-primary-500"
                }`}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* Project Grid */}
        <div className="grid grid-cols-1 min-[460px]:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {visibleProjects.map((project, index) => (
            <ProjectCard key={index} {...project} />
          ))}
        </div>

        {/* Show More Button */}
        {hasMore && (
          <div className="text-center mt-8">
            <button
              onClick={() => setShowAll(!showAll)}
              className="px-6 py-2.5 bg-primary-500 text-white rounded-full font-medium
                         hover:bg-primary-600 transition-all duration-300 shadow-card hover:shadow-card-hover"
            >
              {showAll ? "Show Less" : "Show More"}
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default Portfolio;
